import TagManager from 'react-gtm-module'
import ReactDOM from 'react-dom'
import React from 'react'
import App from './App'

const tagManagerArgs = { gtmId: 'GTM-T2LSVM2' }
TagManager.initialize(tagManagerArgs)
console.disableYellowBox = true

ReactDOM.render(<App />, document.getElementById('root'))
